import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Formik, ErrorMessage, validateYupSchema } from 'formik'
import * as yup from 'yup'
import axios from 'axios'
import AuthorizeComponent from '../../../auth/components/AuthorizeComponent'
import { StyledSearchForm } from '../../../../styled/common-styled'
import { GeneralStyledContent } from '../../../../styled/common-styled'
import Breadcrumb from '../../../shared/components/Breadcrumb'
import LangContext, { i18n } from 'modules/shared/context/langContext'
import moment from 'moment'

import {
  loadStockBalanceDetailIsDirty,
  createStockBalanceFromIsDirty,
  removeLists,
} from '../actions'

import {
  Button,
  Row,
  Col,
  Modal,
  Form,
  Spin,
  Select,
  Descriptions,
  message,
  InputNumber,
} from 'antd'
import FormDivider from '../../../shared/components/FormDivider'

const { confirm } = Modal
const { Option } = Select
const { Item } = Form
const FormItem = Item

class FormManageStockBalanceIsDirty extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {
        id: null,
        stock_date: '',
        plant_id: null,
        plant_name: '',
        plant_code: '',
        material_id: null,
        material_name: '',
        material_code: '',
        material_unit: '',
        bluenet_actual_qty: 0,
        sync_at: '',
        create_by_id: null,
        create_by: null,
        update_by_id: null,
        update_by: null,
        isupply_plant_stock_balance_history_id: null,
        create_stock_balance_list: [],
      },
      validationSchema: yup.object().shape({}),
    }
    this.goBack = this.goBack.bind(this)
  }

  componentDidMount() {
    if (this.props.id) {
      this.loadDataForEdit(this.props.id)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.id != this.props.id) {
      if (
        this.props.id &&
        this.props.serviceType === 'modalCheckSyncMorningStock'
      ) {
        this.loadDataForEdit(this.props.id)
      }
    }
  }

  componentWillUnmount() {
    this.onRemoveLists()
  }

  onRemoveLists = () => {
    this.props.removeLists()
  }

  goBack() {
    this.props.history.goBack()
  }

  loadDataForEdit = (id) => {
    this.props.loadStockBalanceDetailIsDirty({
      id: id,
      accessToken: this.props.auth.accessToken,
    })
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      this.props.isupplyStockBalance.stock_balance_is_dirty_loading !=
        nextProps.isupplyStockBalance.stock_balance_is_dirty_loading &&
      nextProps.isupplyStockBalance.stock_balance_is_dirty_detial != null
    ) {
      let detial = nextProps.isupplyStockBalance.stock_balance_is_dirty_detial
      this.setInitialValues(detial)
    }
    return true
  }

  setInitialValues = (input) => {
    let detail = this.setFormatCreateStockBalanceList(input)

    this.setState({
      data: {
        ...this.state.data,
        ...detail,
        bluenet_actual_qty: detail.actual_qty,
        sync_at: detail.last_update,
      },
    })
  }

  setFormatCreateStockBalanceList = (input) => {
    let create_stock_balance_list = []
    let updateValidationSchema = yup.object().shape({})
    let actual_qty = null

    input.silo_no_list.map((sl) => {
      let silo_no = sl.silo_no
      let stock = sl.data_stock

      create_stock_balance_list.push({
        id: stock.id,
        stock_date: stock.stock_date,
        plant_id: stock.plant_id,
        material_id: stock.material_id,
        silo_no: silo_no,
        qty: stock.qty,
        actual_qty: actual_qty,
        diff_qty: stock.qty,
        create_by_id: this.props.auth.profile.id,
        update_by_id: this.props.auth.profile.id,
        notes_on_stock_adjustments: '',
        remark: '',
        isupply_plant_silo_id: stock.isupply_plant_silo_id,
      })

      input = {
        ...input,
        [`actual_qty_${stock.isupply_plant_silo_id}`]: actual_qty,
      }

      let validationSchema = yup.object()
      validationSchema = validationSchema.shape({
        [`actual_qty_${stock.isupply_plant_silo_id}`]: yup
          .number()
          .min(0)
          .required(i18n[this.props.language].s.stockQuantityIsRequired),
      })

      updateValidationSchema = yup.object().shape({
        ...updateValidationSchema.fields,
        ...validationSchema.fields,
      })
    })
    input.create_stock_balance_list = create_stock_balance_list

    this.setState({
      validationSchema: updateValidationSchema,
    })

    return input
  }

  showConfirmEdit = (values, i18n) => {
    let self = this
    confirm({
      title: i18n.d.doYouWantToEditTheseItems,
      content: i18n.c.confirmToEditThisItem,
      okText: i18n.o.ok,
      cancelText: i18n.c.cancel,
      onOk() {
        self.handleSubmitEdit(values, i18n)
      },
      onCancel() {},
    })
  }

  handleSubmitEdit = (values, i18n) => {
    let self = this
    let create_stock_balance_list = []
    values.create_stock_balance_list.map((v) => {
      let qty = v.qty
      let actual_qty = v.actual_qty
      let diff_qty = v.diff_qty
      if (values.material_unit == 'tonne') {
        qty = qty * 1000
        actual_qty = actual_qty * 1000
        diff_qty = diff_qty * 1000
      }

      if (actual_qty > 0) {
        create_stock_balance_list.push({
          id: v.id,
          stock_date: v.stock_date,
          plant_id: v.plant_id,
          material_id: v.material_id,
          silo_no: v.silo_no,
          qty: qty || 0,
          actual_qty: actual_qty || 0,
          diff_qty: diff_qty || 0,
          create_by_id: v.create_by_id,
          update_by_id: v.update_by_id,
          remark: v.remark,
        })
      }
    })

    this.props.createStockBalanceFromIsDirty(
      {
        id: values.id,
        create_stock_balance_list: create_stock_balance_list,
        accessToken: this.props.auth.accessToken,
      },
      function(res) {
        if (res.status == 'fail') {
          message.error(i18n.u.updateFail)
        } else {
          message.success(i18n.u.updatetSuccess)

          // ถ้ากดมาจาก modal ให้ปิด modal และ refresh หน้านั้น
          if (self.props.serviceType == 'modalCheckSyncMorningStock') {
            self.props.handleCancel()
          } else {
            window.location.replace(`/stock-balance`)
          }
        }
      }
    )
  }

  validateSumStock = (value) => {
    if (value == null || value == undefined) {
      return false
    }

    let validate = true
    let bluenet_actual_qty = value.bluenet_actual_qty || 0
    let silo_actual_qty = 0

    value.create_stock_balance_list.map(
      (v) => (silo_actual_qty = silo_actual_qty + v.actual_qty || 0)
    )

    silo_actual_qty = silo_actual_qty || 0
    silo_actual_qty = Number(silo_actual_qty).toFixed(3)
    bluenet_actual_qty = Number(bluenet_actual_qty).toFixed(3)

    if (bluenet_actual_qty != silo_actual_qty) {
      validate = false
    }
    return validate
  }

  handleFirstUpdateActualQty = (
    value,
    index,
    first_actual_qty,
    setFieldValue
  ) => {
    let bluenet_actual_qty = value.bluenet_actual_qty
    let bluenet_actual_qty_diff = bluenet_actual_qty - first_actual_qty
    let set_value_qty = 0
    let set_value_id = null
    let set_value_index = null

    value.create_stock_balance_list.map((val, i) => {
      if (index != i) {
        set_value_index = i
        set_value_id = val.isupply_plant_silo_id
        set_value_qty = val.qty
      }
    })

    if (set_value_index != null) {
      let qty = set_value_qty
      let actual_qty = bluenet_actual_qty_diff
      let diff_qty = 0
      if (value == null) {
        actual_qty = 0
      }
      diff_qty = actual_qty - qty
      setFieldValue(
        `create_stock_balance_list[${set_value_index}].actual_qty`,
        actual_qty
      )
      setFieldValue(
        `create_stock_balance_list[${set_value_index}].diff_qty`,
        parseFloat(diff_qty).toFixed(3)
      )
      setFieldValue(`actual_qty_${set_value_id}`, actual_qty)

      this.setState({
        first_update_actual_qty: false,
      })
    }
  }

  handleAutoFillRemainingInput = (values, currentIndex, setFieldValue) => {
    let currentActualQty =
      values[
        `actual_qty_${values.create_stock_balance_list[currentIndex].isupply_plant_silo_id}`
      ]

    if (currentActualQty === '' || currentActualQty === null) {
      // ลบค่าที่กรอก
      return
    }

    // TODO:เช็คว่ามีค่าที่เป็น null อยู่ 1 input จะให้ auto fill ใน input นั้น
    let index_null_data = []
    let totalFilledQty = 0
    values.create_stock_balance_list.forEach((item, i) => {
      let actualQty = values[`actual_qty_${item.isupply_plant_silo_id}`]
      if (actualQty === null) {
        index_null_data.push(i)
      }

      totalFilledQty += actualQty || 0
    })

    if (index_null_data.length === 1) {
      if (totalFilledQty <= values.bluenet_actual_qty) {
        let temp_index = index_null_data[0]
        let remainingQty = 0
        remainingQty = values.bluenet_actual_qty - totalFilledQty
        remainingQty = parseFloat(remainingQty.toFixed(3))

        let qty = parseFloat(values.create_stock_balance_list[temp_index].qty)
        let diff_qty = remainingQty - qty
        diff_qty = parseFloat(diff_qty).toFixed(3)

        // TODO:set ค่าให้ input ที่เป็น null
        this.handleSetValueSilo(
          {
            actual_qty: remainingQty,
            diff_qty: diff_qty,
            id: values.create_stock_balance_list[temp_index].id,
            index: temp_index,
            isupply_plant_silo_id:
              values.create_stock_balance_list[temp_index]
                .isupply_plant_silo_id,
          },
          setFieldValue
        )
      }
    } else {
      if (totalFilledQty == values.bluenet_actual_qty) {
        let remainingQty = 0
        remainingQty = values.bluenet_actual_qty - totalFilledQty
        remainingQty = parseFloat(remainingQty.toFixed(3))

        index_null_data.forEach((index) => {
          let qty = parseFloat(values.create_stock_balance_list[index].qty)
          let diff_qty = remainingQty - qty
          diff_qty = parseFloat(diff_qty).toFixed(3)

          // TODO:set ค่าให้ input ที่เป็น null
          this.handleSetValueSilo(
            {
              actual_qty: remainingQty,
              diff_qty: diff_qty,
              id: values.create_stock_balance_list[index].id,
              index: index,
              isupply_plant_silo_id:
                values.create_stock_balance_list[index].isupply_plant_silo_id,
            },
            setFieldValue
          )
        })
      }
    }
  }

  handleSetValueSilo = (data, setFieldValue) => {
    let actual_qty = data['actual_qty']
    let diff_qty = data['diff_qty']
    let isupply_plant_silo_id = data['isupply_plant_silo_id']
    let index_data = data['index']

    setFieldValue(
      `create_stock_balance_list[${index_data}].actual_qty`,
      actual_qty
    )
    setFieldValue(`create_stock_balance_list[${index_data}].diff_qty`, diff_qty)
    setFieldValue(`actual_qty_${isupply_plant_silo_id}`, actual_qty)
  }

  render() {
    const { stock_balance_is_dirty_loading } = this.props.isupplyStockBalance

    const formItemLayout = {
      labelCol: {
        xs: { span: 3 },
        sm: { span: 3 },
        md: { span: 3 },
        lg: { span: 3 },
        xl: { span: 3 },
      },
      wrapperCol: {
        xs: { span: 4 },
        sm: { span: 4 },
        md: { span: 4 },
        lg: { span: 4 },
        xl: { span: 4 },
      },
    }

    return (
      <GeneralStyledContent>
        {/* <Row>
          <Col span={24}>
            <Breadcrumb
              match={this.props.match}
              style={{ margin: "0px 0px 14px 10px" }}
            />
          </Col>
        </Row> */}
        <Row>
          <Spin spinning={stock_balance_is_dirty_loading}>
            <StyledSearchForm>
              <LangContext.Consumer>
                {(i18n) => (
                  <Formik
                    enableReinitialize={true}
                    initialValues={this.state.data}
                    onSubmit={(values) => {
                      this.showConfirmEdit(values, i18n)
                    }}
                    render={({
                      values,
                      errors,
                      status,
                      touched,
                      handleBlur,
                      setFieldValue,
                      handleSubmit,
                    }) => (
                      <div>
                        <Form {...formItemLayout} onSubmit={handleSubmit}>
                          <Row
                            style={{
                              marginLeft: '10px',
                              marginRight: '10px',
                            }}
                          >
                            <FormDivider>ยอดเคาะเช้าจาก Bluenet</FormDivider>
                            <Descriptions
                              column={
                                this.props.serviceType ===
                                'modalCheckSyncMorningStock'
                                  ? 1
                                  : 4
                              }
                            >
                              <Descriptions.Item
                                label={i18n.s.stockDate}
                              >{`${moment(
                                values.sync_at,
                                'YYYY-MM-DD HH:mm:ss'
                              ).format(
                                'DD/MM/YYYY HH:mm:ss'
                              )}`}</Descriptions.Item>
                              <Descriptions.Item
                                label={i18n.i.isupplyPlant}
                              >{`(${values.plant_code}) ${values.plant_name}`}</Descriptions.Item>
                              <Descriptions.Item
                                label={i18n.p.productType}
                              >{`(${values.material_code}) ${values.material_name}`}</Descriptions.Item>
                              <Descriptions.Item
                                label={`ยอดเคาะเช้า (${
                                  i18n.quantityUnit[values.material_unit]
                                })`}
                              >{`${values.bluenet_actual_qty}`}</Descriptions.Item>
                            </Descriptions>

                            <FormDivider>
                              เลือกไซโลของยอดเคาะเช้าจาก Bluenet
                            </FormDivider>
                            <Row>
                              <Col xs={24} sm={24} md={2} lg={2} xl={2} />
                              <Col xs={24} sm={24} md={22} lg={22} xl={22}>
                                <p
                                  style={{
                                    fontSize: '14px',
                                    color: 'rgba(0, 0, 0, 0.85)',
                                  }}
                                >
                                  {`*${i18n.s.stockQuantity} (${
                                    i18n.quantityUnit[values.material_unit]
                                  })`}
                                </p>
                              </Col>
                            </Row>

                            {values.create_stock_balance_list.map(
                              (val, index) => (
                                <Row style={{ marginBottom: '5px' }}>
                                  <FormItem
                                    validateStatus={
                                      touched[
                                        'actual_qty_' +
                                          val.isupply_plant_silo_id
                                      ] &&
                                      errors[
                                        'actual_qty_' +
                                          val.isupply_plant_silo_id
                                      ] &&
                                      'warning'
                                    }
                                    help={
                                      touched[
                                        'actual_qty_' +
                                          val.isupply_plant_silo_id
                                      ] &&
                                      errors[
                                        'actual_qty_' +
                                          val.isupply_plant_silo_id
                                      ]
                                    }
                                    style={{ marginBottom: '10px' }}
                                    label={
                                      <span
                                        style={{
                                          fontSize: '17px',
                                          fontWeight: 600,
                                          color: 'rgba(0, 0, 0, 0.85)',
                                        }}
                                      >
                                        {`Silo ${val.silo_no}`}
                                      </span>
                                    }
                                  >
                                    <InputNumber
                                      name={`actual_qty_${val.isupply_plant_silo_id}`}
                                      value={
                                        values[
                                          'actual_qty_' +
                                            val.isupply_plant_silo_id
                                        ]
                                      }
                                      max={val.container_stock_limit}
                                      min={0}
                                      style={{ width: '100%' }}
                                      onChange={(value) => {
                                        let qty = val.qty
                                        let actual_qty = value
                                        let diff_qty = 0
                                        if (value == null) {
                                          actual_qty = 0
                                        }
                                        diff_qty = actual_qty - qty

                                        setFieldValue(
                                          `create_stock_balance_list[${index}].actual_qty`,
                                          actual_qty
                                        )
                                        setFieldValue(
                                          `create_stock_balance_list[${index}].diff_qty`,
                                          parseFloat(diff_qty).toFixed(3)
                                        )
                                        setFieldValue(
                                          `actual_qty_${val.isupply_plant_silo_id}`,
                                          value
                                        )
                                      }}
                                      onBlur={(e) => {
                                        this.handleAutoFillRemainingInput(
                                          values,
                                          index,
                                          setFieldValue
                                        )
                                      }}
                                      autoComplete='off'
                                    ></InputNumber>
                                  </FormItem>
                                </Row>
                              )
                            )}
                          </Row>
                          <Row
                            style={{
                              marginTop: '30px',
                              marginBottom: '5px',
                              marginLeft: '10px',
                              marginRight: '10px',
                            }}
                          >
                            <Col sm={24} md={5} lg={5} xl={5}>
                              {this.props.serviceType !==
                                'modalCheckSyncMorningStock' && (
                                <Button
                                  type='default'
                                  style={{
                                    marginRight: '10px',
                                  }}
                                  onClick={() =>
                                    window.location.replace(`/stock-balance`)
                                  }
                                >
                                  {i18n.b.back}
                                </Button>
                              )}

                              <Button
                                type='primary'
                                htmlType='submit'
                                disabled={!this.validateSumStock(values)}
                              >
                                {i18n.s.save}
                              </Button>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                    )}
                  />
                )}
              </LangContext.Consumer>
            </StyledSearchForm>
          </Spin>
        </Row>
      </GeneralStyledContent>
    )
  }
}

export default connect(
  ({ isupplyStockBalance, auth, ui: { language } }) => ({
    isupplyStockBalance,
    auth,
    language,
  }),
  {
    loadStockBalanceDetailIsDirty: loadStockBalanceDetailIsDirty.request,
    createStockBalanceFromIsDirty: createStockBalanceFromIsDirty.request,
    removeLists,
  }
)(FormManageStockBalanceIsDirty)
